// extracted by mini-css-extract-plugin
export var actionText = "_kp-4";
export var container = "_kp-0";
export var leftSection = "_kp-1";
export var rightSection = "_kp-2";
export var settingsButton = "_kp-6";
export var settingsIcon = "_kp-7";
export var shortcut = "_kp-5";
export var shortcutGroup = "_kp-3";